import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BlogArticle from "@/pages/blog/complete-kakobuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/complete-kakobuy-spreadsheet-guide",
    element: <BlogArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;